export const REQUEST_TIMEOUT = 15000
export const DEFAULT_CACHE_TTL = 60 * 60 * 1000
